import { render, staticRenderFns } from "./BuildingEditIssuesTab.vue?vue&type=template&id=7701d126"
import script from "./BuildingEditIssuesTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditIssuesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports